module.exports = __webpack_public_path__ + "img/ENT_course_3.a60703f8.jpg";